import * as React from "react";
import styled, { css } from "../../../styled/index";
import {CS} from "../../../styles/index";
import { TopNavMenu as Menu } from "./nav";
import {shadeAlternate} from "../../../styled/helpers";

export interface TopNavWrapperProps extends React.MenuHTMLAttributes<HTMLMenuElement> {
  children: React.ReactNode;
}
export interface TopNavContentProps extends React.HTMLAttributes<HTMLDivElement> {
  width: "full" | "lg" | "md" | "sm" | "xs";
  align: "start" | "space-between" | "space-around";
  children: React.ReactNode;
}
export interface TopNavLogoProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export interface TopNavIconProps extends React.HTMLAttributes<HTMLDivElement> {

}

const WrapperComponent = styled("menu")`
  position: fixed;
  z-index: 10;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  height: ${({theme}) => theme.top_nav.height}px;
  background: ${({theme}) => theme.top_nav.background_color};
  ${CS.shadow.light.two};
`;

const ContentComponent = styled("div")<TopNavContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${({align}) => align};
  padding: 0 20px;
  width: 100%;
  height: 100%;
  max-width: ${({ width, theme }) => width === "full" ? "100%" : `${theme.content_width[width]}px` };
  margin: 0 auto;
  > * {
    margin: 0 20px;
    &:first-child {
      margin-left: 0
    }
    &:last-child {
      margin-right: 0
    }
  }
`;

const LogoComponent = styled("div")<TopNavLogoProps>`
  span {
    font-size: 20px;
    font-weight: 600;
  }
  img {
    max-height: ${({theme}) => theme.top_nav.height - 28}px;
  }
`;

const IconWrapper = styled("div")`
  padding: 8px;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.2s background;
  &:hover {
    background: ${({theme}) => shadeAlternate(0.08, theme.top_nav.background_color)};
  }
`;

const IconComponent = styled("div")`
  font-size: 20px;
`;

const Content: React.SFC<TopNavContentProps> = (props) => <ContentComponent {...props}>{props.children}</ContentComponent>;
const Logo: React.SFC<TopNavLogoProps> = (props) => <LogoComponent {...props}>{props.children}</LogoComponent>;
const Icon = (props: TopNavIconProps) => <IconWrapper {...props}><IconComponent>{props.children}</IconComponent></IconWrapper>;

class Wrapper extends React.Component<TopNavWrapperProps> {

  render() {
    const root = document.getElementById("scroll-root")!;
    const scrollBarWidth = window.innerWidth - root.clientWidth;
    const { props } = this;
    const style = props.style || {};
    style.marginRight = `${scrollBarWidth}px`;
    return (
      <WrapperComponent {...props} style={style}>
        {props.children}
      </WrapperComponent>
    );
  }

}

export const TopNav = {
  Wrapper, Content, Logo, Menu, Icon,
};
